/**
 * ProseMirror rejects empty text nodes when building a doc from JSON
 * ("RangeError: Empty text nodes are not allowed"). TipTap can serialize
 * zero-length text between adjacent marks (e.g. back-to-back inline code).
 * Strip those nodes so stored JSON always round-trips.
 */
export function sanitizeTipTapDocJson(node) {
  if (!node || typeof node !== "object") return node;
  if (node.type === "text") {
    const text = node.text;
    if (text == null || text === "") return null;
    if (typeof text !== "string") return { ...node, text: String(text) };
    return node;
  }
  if (!Array.isArray(node.content)) return node;

  const nextContent = [];
  for (const child of node.content) {
    const cleaned = sanitizeTipTapDocJson(child);
    if (cleaned !== null) nextContent.push(cleaned);
  }

  const out = { ...node };
  if (nextContent.length) {
    out.content = nextContent;
  } else {
    delete out.content;
  }
  return out;
}

/** True when the document has no non-whitespace text (any block type). */
export function isTipTapDocWhitespaceOnly(doc) {
  const collect = (node) => {
    if (!node || typeof node !== "object") return "";
    if (node.type === "text" && typeof node.text === "string") return node.text;
    if (!Array.isArray(node.content)) return "";
    return node.content.map(collect).join("");
  };
  return collect(doc).trim() === "";
}
